<template>
  <div style="height: 100%; display: flex; flex-direction: column;">
    <!-- 顶部筛选栏 -->
    <div style="display: flex; align-items: center; flex-shrink: 0;">
      <el-select
        v-if="$store.state.Login.Jurisdiction == 0"
        size="medium"
        v-model="searchForm.Factory"
        style="width: 150px; margin: 0 10px;"
        clearable
        :placeholder="$t('system.选择厂区')"
      >
        <el-option
          v-for="item in $PublicJs.factory"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <el-input
        size="medium"
        clearable
        v-model="searchForm.Text"
        style="width: 270px; margin-right: 8px;"
        :placeholder="$t('All.品名') + '/' + $t('All.料号')"
      ></el-input>

      <el-button type="primary" icon="el-icon-search" size="small" @click="Butsele">
        {{ $t('All.搜索') }}
      </el-button>
      <el-button type="success" icon="el-icon-plus" size="small" @click="openAddDialog">
        {{ $t('All.新增') }}
      </el-button>
    </div>

    <!-- 表格区域 -->
    <div style="flex: 1; padding: 0 10px;">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
      >
        <el-table-column align="center" type="index" width="60" label="序号"></el-table-column>
        <el-table-column align="center" prop="Date" :label="$t('system.创建日期')" width="170"></el-table-column>
        <el-table-column align="center" prop="Update_time" :label="$t('All.更新时间')" width="170"></el-table-column>
        <el-table-column align="center" prop="Item" :label="$t('All.料号')" width="140"></el-table-column>
        <el-table-column align="center" prop="Name" :label="$t('All.品名')" width="160"></el-table-column>
        <el-table-column align="center" prop="Factory" :label="$t('All.厂区')" width="120"></el-table-column>
        <!-- <el-table-column align="center" prop="User" :label="$t('All.用户名')" width="120"></el-table-column> -->
        <el-table-column align="center" prop="Username" :label="$t('All.姓名')"></el-table-column>
        <el-table-column align="center" fixed="right" :label="$t('system.操作')" width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="openEditDialog(scope.row)">
              编辑
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)" style="margin-left:4px">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <el-pagination
      style="text-align: center; padding: 6px; flex-shrink: 0;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.Pageindex"
      :page-sizes="[15, 30, 50, 80]"
      :page-size="searchForm.PageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="620px"
      append-to-body
      @close="resetForm"
    >
      <el-form ref="form" :model="form" label-width="110px">
        <el-form-item label="料号" prop="Item" :rules="[{required:true,message:'请输入料号',trigger:'blur'}]">
          <el-input v-model="form.Item" style="width: 380px;"></el-input>
        </el-form-item>
        <el-form-item label="品名" prop="Name" :rules="[{required:true,message:'请输入品名',trigger:'blur'}]">
          <el-input v-model="form.Name" style="width: 380px;"></el-input>
        </el-form-item>
        <el-form-item label="厂区" prop="Factory">
          <el-select v-model="form.Factory" clearable placeholder="选择厂区" style="width: 380px;">
            <el-option v-for="item in $PublicJs.factory" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:right">
        <el-button @click="dialogVisible = false">{{ $t('All.取消') }}</el-button>
        <el-button v-if="dialogTitle === $t('All.新增')" type="primary" @click="submitAdd">
          {{ $t('All.提交') }}
        </el-button>
        <el-button v-else type="primary" @click="submitEdit">
          {{ $t('All.提交') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'NocalculateConfig',
  data () {
    return {
      loading: false,
      tableData: [],
      total: 0,
      // 搜索条件
      searchForm: {
        PageSize: 15,
        Pageindex: 1,
        Factory: 'All',
        Text: ''
      },
      // 弹窗基础变量
      dialogVisible: false,
      dialogTitle: '',
      form: {
        Id: 0,
        Name: '',
        Item: '',
        Factory: '',
        Date: '',
        Update_time: '',
        User: '',
        Username: ''
      },
      mockAllData: []
    }
  },
  created () {
    this.GetTableData()
  },
  methods: {
    // 列表查询接口
    async GetTableData () {
      this.loading = true
      try {
        const { data: res } = await this.$http.post('/api/MaterialLabel/GetNocalculateList', this.searchForm)
        if (res.status !== 200) {
          this.$message.error(res.msg || '查询列表失败')
          this.tableData = []
          this.total = 0
          return
        }
        const response = res.response || {}
        this.tableData = response.Nocalculate || []
        this.total = response.TotalCount || 0
      } catch (error) {
        console.error('Error filtering data:', error)
        this.$message.error('列表接口请求异常')
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    // 搜索按钮
    Butsele () {
      this.searchForm.Pageindex = 1
      this.GetTableData()
    },
    // 每页条数切换
    handleSizeChange (val) {
      this.searchForm.PageSize = val
      this.GetTableData()
    },
    // 页码切换
    handleCurrentChange (val) {
      this.searchForm.Pageindex = val
      this.GetTableData()
    },

    // 新增
    openAddDialog () {
      this.resetForm()
      this.dialogTitle = this.$t('All.新增')
      this.form.User = this.$store.state.Login.User || ''
      this.form.Username = this.$store.state.Login.Username || ''
      this.dialogVisible = true
    },
    // 新增保存
    submitAdd () {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        try {
          const postdata = {
            ...this.form,
            Id: 0
          }
          const { data: res } = await this.$http.post('/api/MaterialLabel/AddNocalculate', postdata)
          if (!res || res.status !== 200) {
            this.$message.error(res?.msg || '新增失败')
            return
          }
          this.$message.success('新增成功')
          this.dialogVisible = false
          this.GetTableData()
        } catch (err) {
          console.error('新增接口异常', err)
          this.$message.error('新增请求异常，请重试')
        }
      })
    },

    // 编辑弹窗
    openEditDialog (row) {
      this.resetForm()
      this.dialogTitle = this.$t('All.编辑')
      this.form = { ...row }
      this.dialogVisible = true
    },
    // 编辑保存
    submitEdit () {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        try {
          const { data: res } = await this.$http.post('/api/MaterialLabel/UpdateNocalculate', this.form)
          if (!res || res.status !== 200) {
            this.$message.error(res?.msg || '编辑失败')
            return
          }
          this.$message.success('编辑成功')
          this.dialogVisible = false
          this.GetTableData()
        } catch (err) {
          console.error('编辑接口异常', err)
          this.$message.error('编辑请求异常，请重试')
        }
      })
    },

    // 重置表单（关闭弹窗统一调用）
    resetForm () {
      this.form = {
        Id: null,
        Name: '',
        Item: '',
        Factory: '',
        Date: null,
        Update_time: null,
        User: '',
        Username: ''
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },

    // 删除方法
    handleDelete (row) {
      this.$confirm(
        `确认删除【${row.Item} - ${row.Name}】吗？`,
        this.$t('All.提示'),
        { type: 'warning' }
      ).then(async () => {
        const { data: res } = await this.$http.post(`/api/MaterialLabel/DeleteNocalculate?Id=${row.Id}`)
        if (!res || res.status !== 200) {
          this.$message.error(res?.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        this.GetTableData()
      }).catch(() => {})
    }
  }
}
</script>
  <style lang="less" scoped>
  /deep/ .el-table {
    overflow: visible;
  }
  </style>
